module.exports = __webpack_public_path__ + "static/img/view_img.67c1303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/view_img.jpg
// module id = KEHC
// module chunks = 34